/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getStateCityAsync } from './SearchItemsDataActionExtension.g';
import { IStatesEntity } from './SearchItemsDataServiceEntities.g';

/**
 * Getaddresses Input Action
 */

export interface IITSStateCityInput extends Msdyn365.IActionInput {
    zipCode: string;
}
export class GetZipCodeInput implements Msdyn365.IActionInput {
    public zipCode: string;
    // TODO: Construct the input needed to run the action
    constructor(zipCode: string) {
        this.zipCode = zipCode;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `getStateCity`;
    public getCacheObjectType = () => 'getStateCity';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getStateCityAction(request: IITSStateCityInput, ctx: Msdyn365.IActionContext): Promise<IStatesEntity | null> {
    if (request.zipCode) {
        try {
            const result = await getStateCityAsync({ callerContext: ctx }, request.zipCode); //calling getStateCityAsync API
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IStatesEntity | null>>getStateCityAction,
    // TODO: Give your data action a unique id
    id: `getStateCity`
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
